import { render, staticRenderFns } from "./Configure3DModelScaleUnits.vue?vue&type=template&id=44edf8c2&scoped=true"
import script from "./Configure3DModelScaleUnits.vue?vue&type=script&lang=js"
export * from "./Configure3DModelScaleUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44edf8c2",
  null
  
)

export default component.exports